import React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { useFormContext } from '../FormContext';
import ConfigFieldControl from './components/ConfigFieldControl';
export const FormConfigRequired = () => {
    const { formState, updateElement } = useFormContext();
    const element = formState.selectedFormElement;
    return (React.createElement(ConfigFieldControl, null,
        React.createElement(FormControlLabel, { label: 'Required Field', control: React.createElement(Checkbox, { color: 'primary', className: 'checkbox', checked: Boolean(element.required), onChange: () => updateElement({ required: !element.required }) }) })));
};
export default FormConfigRequired;
//# sourceMappingURL=FormConfigRequired.js.map